/**
 * Retrieves a deeply nested value from a Map
 * @param {Map} baseMap Map to traverse
 * @param {Array} keys List of keys representing path to retrieve
 * @param {*} fallback Value to return when no result was found
 */
export const deepGet = (baseMap, keys, fallback) => {
  const final = keys.reduce((result, key) => {
    const keyExists = result && result.has(key);
    if (keyExists) return result.get(key);
    return null;
  }, baseMap);
  return final || fallback;
};

/**
 * Given a Map and a list of keys, returns a new map with only the specified keys, in the provided order.
 * @param {Map} sourceMap Map with keys to sort
 * @param {Array} keys List of keys in order of which to return sorted Map
 */
export const sortMapKeys = (sourceMap, keys) => {
  const result = new Map();
  keys.forEach((key) => {
    const value = sourceMap.has(key);
    if (value) {
      result.set(key, sourceMap.get(key));
    }
  });
  return result;
};

export default {};
